import {
  getSPDataWithParams,
  postSPData,
} from './services'

export async function getSupportClinicBrandCommsQuota(clinicBrandId) {
  if (!clinicBrandId) {
    throw new Error('clinicBrandId is required')
  }
  return getSPDataWithParams('/api/secure/cc/support/clinic-brand/comms-quota/current', {
    clinicBrandId,
  })
}

export async function getSupportClinicBrandCommsQuotaRequests(clinicBrandId, limit = 20) {
  if (!clinicBrandId) {
    throw new Error('clinicBrandId is required')
  }
  return getSPDataWithParams('/api/secure/cc/support/clinic-brand/comms-quota/requests', {
    clinicBrandId,
    limit,
  })
}

export async function createSupportClinicBrandCommsQuotaPurchaseRequest(payload) {
  return postSPData('/api/secure/cc/support/clinic-brand/comms-quota/purchase-request', payload)
}

export async function allotSupportClinicBrandCommsQuota(payload) {
  return postSPData('/api/secure/cc/support/clinic-brand/comms-quota/allot', payload)
}
